/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a long DNA sequence (FASTA accepted)…`)
};

const es_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia de ADN larga (se acepta FASTA)…`)
};

const de_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine lange DNA-Sequenz ein (FASTA wird akzeptiert)…`)
};

const nl_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een lange DNA-sequentie (FASTA geaccepteerd)…`)
};

const fr_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une longue séquence d'ADN (FASTA accepté)…`)
};

const it_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una lunga sequenza di DNA (FASTA accettato)…`)
};

const pt_br2_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de DNA longa (FASTA aceito)…`)
};

const pt_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de ADN longa (aceita FASTA)…`)
};

const ja_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長いDNA配列を貼り付けてください（FASTA可）…`)
};

const zh_gcskew_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴较长的 DNA 序列（接受 FASTA 格式）…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_input_placeholder", locale)
	if (locale === "en") return en_gcskew_input_placeholder(inputs)
	if (locale === "es") return es_gcskew_input_placeholder(inputs)
	if (locale === "de") return de_gcskew_input_placeholder(inputs)
	if (locale === "nl") return nl_gcskew_input_placeholder(inputs)
	if (locale === "fr") return fr_gcskew_input_placeholder(inputs)
	if (locale === "it") return it_gcskew_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_input_placeholder(inputs)
	if (locale === "pt") return pt_gcskew_input_placeholder(inputs)
	if (locale === "ja") return ja_gcskew_input_placeholder(inputs)
	return zh_gcskew_input_placeholder(inputs)
};